<template>
  <div class="basic_wrap">
    <div class="page_header">
      <div class="red_top_bg">
        <div class="back_left" @click="$router.back()"></div>
        <div class="big_tit">订单详情</div>
      </div>
    </div>

    <div class="content_box" v-if="data.id">
      <div class="status_panel" :class="statusThemeClass">
        <p class="status_title">{{ data.status_text }}</p>
        <p class="status_desc">{{ statusDesc }}</p>
        <div v-if="parseInt(data.status) !== 2 && parseInt(data.status) !== 4" class="status_steps">
          <div class="step" v-for="(step, idx) in steps" :key="step" :class="{ active: idx <= currentStep }">
            <div class="step_dot"></div>
            <p>{{ step }}</p>
          </div>
        </div>
      </div>

      <div class="merchant_card" @click="goMerchantShop">
        <div class="merchant_left">
          <img v-if="data.merchant_logo" :src="data.merchant_logo" alt="" class="merchant_logo" />
          <div v-else class="merchant_logo placeholder"></div>
          <div class="merchant_text">
            <p class="merchant_name">{{ data.merchant_name || '平台自营' }}</p>
            <p class="merchant_desc">{{ data.merchant_description || '点击查看该店铺全部商品' }}</p>
          </div>
        </div>
        <div class="merchant_right">进店逛逛</div>
      </div>

      <div class="card_box">
        <div class="goods_card">
          <img :src="data.item_img" alt="" class="item_img" />
          <div class="item_detail">
            <p class="item_title">{{ data.item_title }}</p>
            <div class="price_row">
              <p class="item_price numberFont"><span>¥</span>{{ formatPrice(data.price) }}</p>
              <p class="item_qty">x{{ data.quantity }}</p>
            </div>
          </div>
        </div>
        <div class="desc_rows" v-if="!isPayFailed">
          <div class="desc_row">
            <span>配送方式</span>
            <span>{{ data.delivery_text || '自动发货' }}</span>
          </div>
          <div class="desc_row">
            <span>买家留言</span>
            <span>{{ data.buyer_remark || '-' }}</span>
          </div>
        </div>
      </div>

      <div v-if="isCardGoods && !isPayFailed" class="card_box">
        <div class="section_title">卡密信息</div>
        <div v-if="hasCardInfo" class="secret_box">
          <div v-if="rawCardNo" class="secret_row">
            <span class="secret_label">卡号:</span>
            <span class="secret_value">{{ rawCardNo }}</span>
            <span class="copy_btn" @click.stop="copyText(rawCardNo)">复制</span>
          </div>
          <div v-if="rawCardPwd" class="secret_row">
            <span class="secret_label">密码:</span>
            <span class="secret_value">{{ rawCardPwd }}</span>
            <span class="copy_btn" @click.stop="copyText(rawCardPwd)">复制</span>
          </div>
          <div v-if="data.card_status && data.card_status !== '发放中'" class="secret_row">
            <span class="secret_label">状态:</span>
            <span class="secret_value">{{ data.card_status }}</span>
          </div>
        </div>
        <div v-if="!hasCardInfo && isCardRefunded" class="empty_tip">卡券发放失败，订单金额已退回余额</div>
        <div v-if="!hasCardInfo && !isCardRefunded" class="empty_tip">卡密发放中，预计24小时内自动到账，请耐心等待</div>
        <div v-if="hasCardInfo" class="secret_tip">{{ data.card_tips || '卡密由系统自动生成，请复制保存后使用' }}</div>
      </div>

      <div v-if="isPhysicalGoods && hasAddressInfo" class="card_box">
        <div class="section_title">收货地址</div>
        <div class="address_box">
          <p class="address_name">
            {{ data.customer_name }}
            <span>{{ data.customer_tel }}</span>
          </p>
          <p class="address_detail">{{ fullAddress }}</p>
        </div>
      </div>

      <div class="card_box">
        <div class="info_row">
          <span class="label">订单编号</span>
          <div class="value_group">
            <span class="value">{{ data.order_no }}</span>
            <span class="copy_btn" @click.stop="copyText(data.order_no)">复制</span>
          </div>
        </div>
        <div class="info_row">
          <span class="label">下单时间</span>
          <span class="value">{{ data.create_time || '-' }}</span>
        </div>
        <div class="info_row">
          <span class="label">支付时间</span>
          <span class="value">{{ data.pay_time || data.create_time || '-' }}</span>
        </div>
        <div class="info_row">
          <span class="label">订单状态</span>
          <span class="value highlight">{{ data.status_text }}</span>
        </div>
      </div>

      <div class="card_box amount_box">
        <div class="amount_row">
          <span>商品总价</span>
          <span class="numberFont">¥{{ formatPrice(data.total_amount) }}</span>
        </div>
        <div class="amount_row pay_row">
          <span>实付款</span>
          <span class="pay_amount numberFont">¥{{ formatPrice(data.pay_amount || data.total_amount) }}</span>
        </div>
      </div>
    </div>

    <div v-if="data.id" class="bottom_bar">
      <div class="bottom_inner">
        <!-- <div class="ghost_btn" @click="goMerchantShop">店铺商品</div> -->
        <div class="ghost_btn" @click="handleBuyAgain">再次购买</div>
        <div v-if="parseInt(data.can_receive) === 1" class="primary_btn" @click="handleReceive">确认收货</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import Fetch from '../../utils/fetch';

export default {
  name: "shopOrderDetail",
  data() {
    return {
      data: {},
    };
  },
  computed: {
    steps() {
      // 支付失败订单不展示进度条
      if (parseInt(this.data.status) === 4) return [];
      // 卡券：待支付→未发货→发货成功→已完成；实物：待支付→待收货→已完成
      if (parseInt(this.data.goods_type) === 1) {
        return ['待支付', '未发货', '发货成功', '已完成'];
      }
      return ['待支付', '待收货', '已完成'];
    },
    currentStep() {
      var status = parseInt(this.data.status);
      var goodsType = parseInt(this.data.goods_type);
      if (status === 4) return -1;
      if (status === 3) return goodsType === 1 ? 3 : 2;
      if (status === 1) {
        if (goodsType === 1) return this.hasCardInfo ? 2 : 1;
        return 1;
      }
      return 0;
    },
    statusThemeClass() {
      var status = parseInt(this.data.status);
      if (status === 4) return 'is_fail';
      if (status === 3) return 'is_done';
      if (status === 2) {
        if (this.isCardRefunded) return 'is_fail';
        return 'is_cancel';
      }
      if (status === 1) return 'is_wait';
      return 'is_pending';
    },
    statusDesc() {
      var status = parseInt(this.data.status);
      var goodsType = parseInt(this.data.goods_type);
      if (status === 4) return '订单支付失败，未扣款，可重新下单购买';
      if (status === 3) {
        if (goodsType === 1 && !this.hasCardInfo) return '订单已完成，卡券发放失败，金额已退回余额';
        return '订单已完成，感谢您的购买';
      }
      if (status === 2) {
        if (goodsType === 1 && this.isCardRefunded) return '卡券发放失败，订单金额已退回余额';
        return '订单已取消，如需购买可再次下单';
      }
      if (status === 1) {
        if (goodsType === 1) {
          if (this.hasCardInfo) return '商品已发货成功，卡密已发放，请确认收货';
          return '订单已支付，商品未发货，预计24小时内自动发货';
        }
        if (parseInt(this.data.delivery_status) === 1) return '商品已发货，请核对信息后确认收货';
        return '商家正在处理订单，发货后可在订单中查看物流信息';
      }
      return '订单待支付，请尽快完成支付';
    },
    rawCardNo() {
      return this.pickValue(['card_no', 'card', 'kami', 'cardnum', 'kahao']);
    },
    rawCardPwd() {
      return this.pickValue(['card_pwd', 'card_password', 'pwd', 'password', 'kamipwd', 'mima']);
    },
    hasCardInfo() {
      return !!(this.rawCardNo || this.rawCardPwd);
    },
    isCardRefunded() {
      return this.data.card_status_raw === '已退款';
    },
    isCardGoods() {
      return parseInt(this.data.goods_type) === 1;
    },
    isPayFailed() {
      return parseInt(this.data.status) === 4;
    },
    isPhysicalGoods() {
      return parseInt(this.data.goods_type) === 0;
    },
    hasAddressInfo() {
      return !!(this.data.customer_name || this.data.customer_tel || this.fullAddress);
    },
    fullAddress() {
      return [
        this.data.province || '',
        this.data.city || '',
        this.data.county || '',
        this.data.address || ''
      ].filter(Boolean).join(' ');
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    formatPrice(price) {
      var num = parseFloat(price) || 0;
      return num.toFixed(2);
    },
    pickValue(keys) {
      for (var i = 0; i < keys.length; i++) {
        var val = this.data[keys[i]];
        if (val !== undefined && val !== null && String(val).trim() !== '') {
          return String(val);
        }
      }
      return '';
    },
    start() {
      var id = this.$router.history.current.params.id;
      Fetch('/shop/order_detail', { id: id }).then((r) => {
        this.data = r.data || {};
      });
    },
    copyText(text) {
      text = String(text || '');
      if (!text) {
        this.$toast('暂无可复制内容');
        return;
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$toast('复制成功');
        }).catch(() => {
          this.fallbackCopy(text);
        });
        return;
      }
      this.fallbackCopy(text);
    },
    fallbackCopy(text) {
      var input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast('复制成功');
    },
    goMerchantShop() {
      if (!this.data.merchant_id) {
        this.$toast('暂无店铺信息');
        return;
      }
      this.$router.push({
        path: '/type',
        query: {
          merchant_id: this.data.merchant_id,
          type1: this.data.merchant_name || '品牌好店'
        }
      });
    },
    handleBuyAgain() {
      if (!this.data.item_id) {
        this.$toast('商品已不存在');
        return;
      }
      Fetch('/shop/item_view', { id: this.data.item_id }).then(() => {
        this.$router.push('/details/' + this.data.item_id);
      }).catch(() => {});
    },
    handleReceive() {
      Dialog.confirm({
        title: '确认收货',
        message: '确认已收到商品后，将把该订单变更为已完成。'
      }).then(() => {
        Fetch('/shop/confirm_receive', { id: this.data.id }).then(() => {
          this.$toast('确认收货成功');
          this.start();
        });
      }).catch(() => {});
    }
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  min-height: 100vh;
  background: #F6F7FB;
  padding-top: 48px;
  padding-bottom: 88px;
}
.page_header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  z-index: 20;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.06);
  
}
.header_inner {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back_left {
  position: absolute;
  left: 0;
  top: 12px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: url(../images/item/back.png) no-repeat center center;
  background-size: auto 100%;
}
.big_tit {
  font-size: 17px;
  font-weight: 600;
  color: #FFFFFF;
}
.content_box {
  padding: 0 12px 16px;
}
.status_panel {
  margin: 12px 0;
  padding: 18px 16px 16px;
  border-radius: 0 0 18px 18px;
  color: #FFFFFF;
  &.is_wait {
    background: linear-gradient(135deg, #FF6A3D 0%, #FF7E53 100%);
  }
  &.is_done {
    background: linear-gradient(135deg, #18B566 0%, #35C67D 100%);
  }
  &.is_cancel {
    background: linear-gradient(135deg, #8C8C8C 0%, #A3A3A3 100%);
  }
  &.is_fail {
    background: linear-gradient(135deg, #E3382E 0%, #F0564C 100%);
  }
  &.is_pending {
    background: linear-gradient(135deg, #4D8DFF 0%, #67A5FF 100%);
  }
  .status_title {
    font-size: 24px;
    font-weight: 600;
  }
  .status_desc {
    margin-top: 6px;
    font-size: 13px;
    opacity: .92;
  }
}
.status_steps {
  margin-top: 18px;
  padding: 14px 12px 8px;
  border-radius: 14px;
  background: rgba(255,255,255,.16);
  display: flex;
  justify-content: space-between;
  .step {
    flex: 1;
    position: relative;
    text-align: center;
    color: rgba(255,255,255,.65);
    &:not(:last-child):after {
      content: '';
      position: absolute;
      top: 6px;
      left: calc(50% + 10px);
      right: calc(-50% + 10px);
      height: 1px;
      background: rgba(255,255,255,.35);
    }
    &.active {
      color: #FFFFFF;
      .step_dot {
        background: #FFFFFF;
        box-shadow: 0 0 0 4px rgba(255,255,255,.18);
      }
      &:not(:last-child):after {
        background: rgba(255,255,255,.85);
      }
    }
    p {
      font-size: 11px;
      margin-top: 10px;
    }
  }
  .step_dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: rgba(255,255,255,.45);
    margin: 0 auto;
  }
}
.merchant_card,
.card_box {
  background: #FFFFFF;
  border-radius: 14px;
  box-shadow: 0px 4px 18px rgba(31, 35, 41, 0.08);
}
.merchant_card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  margin-bottom: 12px;
}
.merchant_left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}
.merchant_logo {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #F2F3F5;
  object-fit: cover;
  flex-shrink: 0;
  &.placeholder {
    position: relative;
    &:after {
      content: '';
      position: absolute;
      inset: 13px;
      border-radius: 50%;
      background: #D9DBE1;
    }
  }
}
.merchant_text {
  min-width: 0;
  margin-left: 12px;
}
.merchant_name {
  font-size: 15px;
  font-weight: 600;
  color: #1F2329;
}
.merchant_desc {
  margin-top: 4px;
  font-size: 12px;
  color: rgba(31,35,41,.55);
}
.merchant_right {
  font-size: 12px;
  color: #FF6A3D;
  font-weight: 600;
  margin-left: 12px;
}
.card_box {
  padding: 14px;
  margin-bottom: 12px;
}
.goods_card {
  display: flex;
  align-items: flex-start;
  background: #F8F9FC;
  border-radius: 12px;
  padding: 10px;
}
.item_img {
  width: 84px;
  height: 84px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
}
.item_detail {
  flex: 1;
  margin-left: 12px;
}
.item_title {
  font-size: 15px;
  line-height: 21px;
  font-weight: 600;
  color: #1F2329;
}
.price_row {
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_price {
  font-size: 18px;
  color: #E3382E;
  font-weight: 700;
  span {
    font-size: 12px;
  }
}
.item_qty {
  font-size: 13px;
  color: rgba(31,35,41,.55);
}
.desc_rows {
  padding-top: 12px;
}
.desc_row,
.info_row,
.amount_row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 13px;
}
.desc_row {
  color: rgba(31,35,41,.72);
  padding-top: 10px;
  span:last-child {
    margin-left: 12px;
    text-align: right;
    color: #1F2329;
  }
}
.section_title {
  font-size: 15px;
  font-weight: 600;
  color: #1F2329;
  margin-bottom: 12px;
}
.secret_box {
  background: #F8F9FC;
  border-radius: 12px;
  padding: 4px 12px;
}
.secret_row {
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 14px;
  &:not(:last-child) {
    border-bottom: 1px solid #ECEEF3;
  }
}
.secret_label {
  width: 42px;
  color: rgba(31,35,41,.7);
}
.secret_value {
  flex: 1;
  color: #1F2329;
  word-break: break-all;
}
.copy_btn {
  flex-shrink: 0;
  margin-left: 10px;
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(255, 106, 61, 0.12);
  color: #FF6A3D;
  font-size: 12px;
}
.empty_tip {
  margin-top: 10px;
  font-size: 13px;
  color: rgba(31,35,41,.45);
}
.address_box {
  background: #F8F9FC;
  border-radius: 12px;
  padding: 14px 12px;
}
.address_name {
  font-size: 15px;
  font-weight: 600;
  color: #1F2329;
  span {
    margin-left: 12px;
    font-size: 13px;
    font-weight: normal;
    color: rgba(31,35,41,.6);
  }
}
.address_detail {
  margin-top: 8px;
  font-size: 13px;
  line-height: 19px;
  color: rgba(31,35,41,.72);
  word-break: break-all;
}
.secret_tip {
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
  color: rgba(31,35,41,.55);
}
.info_row {
  padding: 10px 0;
  &:not(:last-child) {
    border-bottom: 1px solid #F2F3F5;
  }
  .label {
    color: rgba(31,35,41,.6);
  }
  .value {
    margin-left: 12px;
    color: #1F2329;
    text-align: right;
    word-break: break-all;
  }
  .highlight {
    color: #FF6A3D;
    font-weight: 600;
  }
}
.value_group {
  display: flex;
  align-items: center;
  margin-left: 12px;
  min-width: 0;
  .value {
    margin-left: 0;
  }
}
.amount_box {
  padding-top: 4px;
  padding-bottom: 4px;
}
.amount_row {
  padding: 10px 0;
  color: #1F2329;
}
.pay_row {
  border-top: 1px solid #F2F3F5;
  font-weight: 600;
}
.pay_amount {
  color: #E3382E;
  font-size: 20px;
}
.bottom_bar {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  max-width: 500px;
  background: #FFFFFF;
  box-shadow: 0px -4px 18px rgba(31, 35, 41, 0.08);
  z-index: 20;
}
.bottom_inner {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
}
.ghost_btn,
.primary_btn {
  min-width: 96px;
  height: 38px;
  line-height: 38px;
  text-align: center;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
}
.ghost_btn {
  border: 1px solid #FFB49E;
  color: #FF6A3D;
  background: #FFFFFF;
}
.primary_btn {
  color: #FFFFFF;
  background: linear-gradient(135deg, #FF6A3D 0%, #FF824B 100%);
}
</style>
